const tourOpts = {
    name: 'basicSearchTour',
    template: '<div class="popover popover--tour" role="tooltip"> <div class="arrow"></div> <h3 class="popover-title popover-title--tour"></h3> <div class="popover-content popover-content--tour"></div> <div class="popover-navigation"> <button class="btn btn-primary" data-role="prev">PREV</button> <button class="btn btn-primary" data-role="next">NEXT</button> <button class="btn btn-primary" data-role="pause-resume" data-pause-text="PAUSE" data-resume-text="RESUME">PAUSE</button>  <button class="btn btn-primary" data-role="end">All DONE</button> </div> </div>',
    debug: true,
    steps: [
        {
            element: '#l-q',
            title: 'Searching Overview (1/8)',
            content: 'New to the Digital Library? This brief guide will show you the basics of searching.',
            placement: 'right',
        },
        {
            element: '#q',
            title: 'Your Terms (2/8)',
            content: 'Your term or phrase goes here. No need to capitalize. Enclose phrases in quotation marks. Entering more words and phrases narrows your results.',
            placement: 'bottom',
        },
        {
            element: '#search-t-btn',
            title: 'Search Type (3/8)',
            content: 'Your search always covers both the full text of Digital Library items and information in their descriptions unless you change this value.',
            placement: 'left',
            onShown(quickSearchTour) {
                $('#search-t-btn').dropdown('toggle');
            },
        },
        {
            element: '#search-navigation',
            title: 'Filters (4/8)',
            content: 'Too many results? Only need newspapers from the 1990s? Choose a filter to quickly limit results. ',
            placement: 'right',
        },
        {
            element: '#sort-results',
            title: 'Sorting (5/8)',
            content: 'By default, we sort results by best match. Use these options to sort in a different way.',
            placement: 'top',
            onShown(quickSearchTour) {
                $('#sort-button').dropdown('toggle');
            },
        },
        {
            element: '#toggle-display',
            title: 'Display (6/8)',
            content: 'You can choose to switch between a list and a grid.',
            placement: 'top',
        },
        {
            element: '#result-1',
            title: 'Results List (7/8)',
            content: 'Click any title or thumbnail image in the search results list to learn more about and interact with the item. During this visit we’ll add check marks next to results titles to help you keep track of items you’ve already seen.</p>',
            placement: 'top',
        },
        {
            element: '#header-search-options',
            title: 'New Search (8/8)',
            content: 'Finally, you can click the search icon [magnifying glass] near the top of any screen to start a new search. You’ve got the basics down. Click ALL DONE to get started.',
            placement: 'bottom',
        },

    ],
};

export default tourOpts;
